var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationConfig',{attrs:{"sIdModule":_vm.nIdModule,"sTitleMenu":_vm.sTitleModule}})}
var staticRenderFns = []

export { render, staticRenderFns }